import React from "react";

export default function PanchashilaFrame6({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>{".cls-pan61{fill:#e21d27}.cls-pan62{fill:#eae4e4}"}</style>
        </defs>
        <path
          d="M1372.56 1452.13c186.07-200.55 286.35-226.99 344.29-205.43 32.92 12.25 73.2 47.83 135.6 43.12 42.44-3.21 75.99-23.61 98.1-40.86-6.89-86.87-13.78-173.74-20.66-260.61-19.57 21.46-50.29 47.98-92.7 56.86-40.52 8.49-72.7-3.09-91.49-7.88-47.97-12.22-122.85-9.27-238.8 62.06 6.52 29.79 19.5 108.04-15.09 197.75-33.98 88.1-94.47 137.02-119.24 154.99ZM606.39 1439.66c-175.5-190.86-269.9-211.27-323.92-192.95-35.72 12.11-74.07 46.98-135.6 43.12-42.36-2.66-75.78-24.41-97.43-42.4l17.34-225.64c25.27 4.95 63.82 11.31 111.34 14.23 38.61 2.38 66.49 1.46 75.5 1.32 46-.75 119.41 10.08 238.8 62.06-6.64 32.08-18.11 109.35 15.1 197.75 28.03 74.61 74.31 121.01 98.87 142.51Z"
          className="cls-pan62"
        />
        <path
          d="M1502.62 1166.59c96.65-110.3 163.14-128.1 207.96-119.88 42.4 7.78 73.62 40.37 134.41 37.3 38.4-1.94 69.35-17.13 90.08-30.26-3.99-50.43-7.98-100.87-11.96-151.3-24.58 9.41-59.87 18.32-98.52 9.85-42.31-9.27-62.47-33.62-85.41-46.7-38.08-21.72-105.97-24.98-236.71 53.69-11.53 40.63-22.58 100.26-14.96 171.06 3.09 28.68 8.7 54.24 15.13 76.25ZM496.7 1166.6c-96.65-110.3-163.14-128.1-207.96-119.88-42.4 7.78-73.62 40.37-134.41 37.3-38.4-1.94-69.35-17.13-90.08-30.26 3.99-50.43 7.98-100.87 11.96-151.3 24.58 9.41 59.87 18.32 98.52 9.85 42.31-9.27 62.47-33.62 85.41-46.7 38.08-21.72 105.97-24.98 236.71 53.69 11.53 40.63 22.58 100.26 14.96 171.06-3.09 28.68-8.7 54.24-15.13 76.25Z"
          className="cls-pan61"
        />
        <path d="M469.15 290.49v858.27c0 127.6 68.23 248.41 185.74 328.83l338.87 231.93 4.25-2.86 340.05-229.02c119.35-80.37 188.82-202.16 188.82-330.93V290.49H469.15Zm970.42 859.02c0 62.52-50.69 113.21-113.21 113.21h-656.7c-62.52 0-113.21-50.69-113.21-113.21v-656.7c0-62.52 50.69-113.21 113.21-113.21h656.7c62.52 0 113.21 50.69 113.21 113.21v656.7Z" />
        <path
          d="M492.24 317.04v826.15a343 343 0 0 0 .42 16.98c5.75 116.5 70.49 225.71 178.37 299.54l326.19 223.25 4.09-2.75 327.32-220.45c108.97-73.38 174.74-182.63 181.22-299.47.35-6.33.53-12.69.53-19.07V317.04H492.24Zm934.1 826.87c0 60.18-48.79 108.97-108.97 108.97H685.25c-60.18 0-108.97-48.79-108.97-108.97V511.79c0-60.18 48.79-108.97 108.97-108.97h632.12c60.18 0 108.97 48.79 108.97 108.97v632.12Z"
          className="cls-pan61"
        />
        {children}
      </g>
    </svg>
  );
}
